import { useCurrentModule } from '../components';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
export const useEffectiveRecommendation = (productId, catalogIsRecommended) => {
  const module = useCurrentModule();
  const {
    isEnabled,
    isLoading
  } = useAiRecommendationEnabled();
  const isRevealed = module.SDK.aiRecommendationStore.useIsRevealed();
  const aiRecommendedProductId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  if (isLoading) {
    return {
      isRecommended: false,
      isAiRecommended: false
    };
  }
  if (!isEnabled) {
    return {
      isRecommended: catalogIsRecommended,
      isAiRecommended: false
    };
  }
  const isAiRecommended = isRevealed && !!aiRecommendedProductId && aiRecommendedProductId === productId;
  return {
    isRecommended: isAiRecommended,
    isAiRecommended
  };
};
//# sourceMappingURL=useEffectiveRecommendation.js.map